import { MethodsEnum } from "../enums/Methods.ts";
import { Instrumentador } from "../models/Instrumentador.ts";
import handleService from "./apiService.ts";
import { emitirNotificacao } from "../contexts/NotificationContext.tsx";

const create = async (instrumentador: Instrumentador) => {
  // id nunca deve ser enviado num cadastro novo - ver pacienteService.create para o motivo.
  const { id, ...instrumentadorSemId } = instrumentador as any;
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/instrumentador",
    data: instrumentadorSemId,
  });
  if (result?.data?.id) {
    emitirNotificacao({
      id: `cadastro-instrumentador-${result.data.id}`,
      tipo: "cadastro_instrumentador",
      titulo: "Novo instrumentador cadastrado",
      descricao: `${result.data.nome} foi adicionado ao cadastro de instrumentadores.`,
      link: "/instrumentador/listagem",
    });
  }
  return result;
};

const update = async (instrumentador) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/instrumentador/alterar",
    data: instrumentador,
  });
  return result;
};

const instrumentadorService = { create, update };

export default instrumentadorService;
